import _plugin_vue_export_helper_default from "../_virtual/_plugin-vue_export-helper.js";
import Start_vue_vue_type_script_setup_true_lang_default from "./Start.vue_vue_type_script_setup_true_lang.js";
/* empty css                                                          */
//#region src/views/Start.vue
var Start_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Start_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-b27bdc01"]]);
//#endregion
export { Start_default as default };

//# sourceMappingURL=Start.vue.js.map